<template>
  <div class="cf-star-rating">
    <div class="cf-star-rating__options">
      <button
        v-for="(option, index) in options"
        :key="index"
        class="cf-button"
        type="button"
        @click="selectRatingClickHandler(option)"
      >
        <span
          :class="[
            'cf-icon cf-icon--smedium',
            { 'cf-icon--gray far fa-star': option > selectedValue },
            { 'cf-icon--brand-primary fa fa-star': option <= selectedValue},
          ]"
        />
      </button>
    </div>
  </div>
</template>


<script>
  export default {
    name: 'CfStarRating',

    props: {
      selectedValue: {
        type: Number,
        default: 0
      }
    },

    data() {
      return {
        options: [1, 2, 3, 4, 5]
      };
    },

    methods: {
      selectRatingClickHandler(option) {
        this.$emit('set-selected-value', option);
      }
    }
  };
</script>
